import { useParams } from 'react-router-dom';
import { NarrativeEditHistory } from './NarrativeEditHistory';


export function NarrativeEditHistoryPage() {
  let { narrativeId } = useParams();
  
  return <NarrativeEditHistory narrativeId={narrativeId} />
}
